import { faMapLocation } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import location from "../../assets/images/location-pink.svg"

function ExploreCities() {
  const cities = ['Leeds', 'Birmingham', 'Liverpool', 'Edinburgh', 'Manchester', 'London', 'Sheffield', 'Bristol', 'Bradford'];

  return (
    <section className="events-section pt-5 position-relative">
      <div className="d-flex align-items-center justify-content-between">
        <h3 className="mb-4">Explore Events in the Cities</h3>
      </div>
      <div className="d-flex flex-wrap gap-3">
        {cities.map((city, index) => (
          <button
            key={index}
            className="btn btn-secondary-location d-flex align-items-center gap-2"
          >
            <img src={location} alt="location" className="img-fluid" /> 
            {city}
          </button>
        ))}
      </div>
    </section>


  );
}

export default ExploreCities;
